import { properCase } from "LIB/formatters/text";

export const OVERHAULED = "overhauled";
export const REPAIRED = "repaired";
export const INSPECTED = "inspected";
export const NEW = "new_item";
export const AS_REMOVED = "as_removed";
export const BEYOND_REPAIR = "beyond_econ_repair";
export const SERVICEABLE_TOOLING = "serviceable_tooling";

export const MODIFIED = "modified";
export const STANDARD = "standard";
export const NO_QUOTE = "no_quote";
export const AWAITING_REPLY = "awaiting_reply";
export const NOT_AWAITING_REPLY = "not_awaiting_reply";
export const MAKE_OFFER = "make_offer";
export const AS_IS = "as_is";
export const EXCHANGE_ONLY = "exchange_only";
export const FULL = "full";
export const INCIDENT_RELATED = "incident_related";
export const NONE = "none";
export const OFFER = "offer";
export const PARTIAL = "partial";
export const PURCHASE_STATUS = "purchase_status";
export const PURCHASE_STATUS_LABEL = "Purchase Qty Remaining";
export const RFQ_AS_ALT_ID = "rfq_as_alt_id";
export const SEND_QUOTE = "send_quote";

export const INCOMING_LINE_ITEMS = {
  condition: {
    [OVERHAULED]: {
      abbrev: "OH",
      label: "Overhauled"
    },
    [REPAIRED]: {
      abbrev: "SV",
      label: "Repaired"
    },
    [INSPECTED]: {
      abbrev: "BT",
      label: "Inspected"
    },
    [NEW]: {
      abbrev: "NE",
      label: "New"
    },
    [AS_REMOVED]: {
      abbrev: "AR",
      label: "As Removed"
    },
    [BEYOND_REPAIR]: {
      abbrev: "BR",
      label: "Beyond Repair"
    },
    [SERVICEABLE_TOOLING]: {
      abbrev: "SV",
      label: properCase(SERVICEABLE_TOOLING)
    }
  },
  quoteType: {
    [STANDARD]: {
      label: "Standard",
      abbrev: "Std"
    },
    [NO_QUOTE]: {
      label: "No Quote",
      abbrev: "NQ"
    },
    [AWAITING_REPLY]: {
      label: "Awaiting Reply",
      abbrev: "Awaiting"
    },
    [NOT_AWAITING_REPLY]: {
      label: "Rfq Closed",
      abbrev: "RfqClosed"
    },
    [MAKE_OFFER]: {
      label: "Make Offer",
      abbrev: "MakeOffer"
    },
    [AS_IS]: {
      label: "As Is",
      abbrev: "As Is"
    },
    [INCIDENT_RELATED]: {
      label: "Incident Related",
      abbrev: "Incident"
    },
    [EXCHANGE_ONLY]: {
      label: "Exchange Only",
      abbrev: "Exch Only"
    },
    [OFFER]: {
      label: "Offer",
      abbrev: "Offer"
    }
  },
  traceTypes: {
    121: {
      label: "121",
      abbrev: "121"
    },
    125: {
      label: "125",
      abbrev: "125"
    },
    129: {
      label: "129",
      abbrev: "129"
    },
    135: {
      label: "135",
      abbrev: "135"
    },
    145: {
      label: "145",
      abbrev: "145"
    },
    part_91: {
      label: "Part 91",
      abbrev: "Part91"
    },
    foreign_part_91: {
      label: "Foreign Part 91",
      abbrev: "FrgnPrt91"
    },
    certificate_of_conformance: {
      label: "C of C Only",
      abbrev: "C of C"
    },
    foreign_operator: {
      label: "Foreign Operator",
      abbrev: "FrgnOp"
    },
    foreign_repair_station: {
      label: "Foreign Repair Station",
      abbrev: "Frgn145"
    },
    ntr: {
      label: "No Trace",
      abbrev: "NoTrace"
    },
    oem: {
      label: "OEM",
      abbrev: "OEM"
    },
    unknown: {
      label: "Unknown",
      abbrev: "UNK"
    }
  }
};

export const PURCHASE_STATUS_OPTIONS = [
  { value: PARTIAL, text: "Partial Purchase" },
  { value: FULL, text: "Full Purchase " }
];

export const ATTACHMENT_TYPES = {
  tag_copies: {
    label: "Tag Copies"
  },
  traceability: {
    label: "Traceability"
  },
  photos: {
    label: "Photos"
  },
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  external_link: {
    label: "External Link"
  }
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/constants.js